import React from "react";
import OwLabel from "../OwLabel/OwLabel";
import OwTranslate from "../OwTranslate/OwTranslate";

type Props = {
    /**
     * Translation id of the explanation. Rendered as text with newlines preserved. Ignored when children are given.
     */
    subject?: string;
    /**
     * Rich explanation (lists, colours, links). Takes precedence over `subject`.
     */
    children?: React.ReactNode;
    className?: string;
};

/**
 * "What's this?" toggle that expands to show an explanation underneath, either a plain translated `subject`
 * or arbitrary children for richer content.
 */
const WhatsThis = (props: Props) => {
    const [displayHowTo, setDisplayHowTo] = React.useState(false);

    const toggleHowTo = () => {
        setDisplayHowTo(!displayHowTo);
    };

    return (
        <div className={"WhatsThis " + (props.className || "")}>
            <div className={"mb-2"}>
                <span className="pointer faded-orange" onClick={toggleHowTo}>
                    <i className="fas fa-info-circle" /> <OwTranslate defaultMessage={"What's this"} id={"whats_this"} />?
                </span>
            </div>
            {props.children !== undefined && props.children !== null ? (
                <div className={"text-muted " + (displayHowTo ? "" : "d-none")}>{props.children}</div>
            ) : (
                // Kept as a <ul> so existing subject callers and the tests that target it keep working.
                <ul className={"text-muted " + (displayHowTo ? "" : "d-none")}>
                    <p>{props.subject ? <OwLabel title={props.subject} preserveNewlines={true} /> : null}</p>
                </ul>
            )}
        </div>
    );
};

export default WhatsThis;
